import styled from 'styled-components'

export const GenresSelectItem = styled.div`
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #646877;
`
export const ListWrapper = styled.div`
  div {
    &::-webkit-scrollbar {
      width: 4px;
      padding-top: 14px;
    }

    &::-webkit-scrollbar-track {
      background: #f9f9f9;
      border-radius: 7px;
      padding-top: 40px;
    }

    &::-webkit-scrollbar-thumb {
      background: #cccccc;
      height: 49px;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #cccccc;
    }
  }
`
